module.exports = __webpack_public_path__ + "static/media/PALOSANTO_02.0d632a40.png";